import { blipSupportSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostNameTenant, messaginghubWebsocketHostName } from 'app.constants';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
export class BlipSupportController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'AuthenticationService', 'TenantService'];
    constructor(LoadingService, TranslateService, AccountService2, $state, AuthenticationService, TenantService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.$state = $state;
        this.AuthenticationService = AuthenticationService;
        this.TenantService = TenantService;
        this.settingsSource = blipSupportSettingsSource;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.blipClusterUrl = blipDomainUrl;
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.stopLoading();
    }
    async $onInit() {
        this.account = await this.AccountService2.me();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.cluster = this.blipClusterUrl.replace('https://', '').split('.')[0];
        this.tenants = await this.loadTenants();
        await this.checkFeatures();
    }
    async loadTenants() {
        const { items: tenants } = await this.TenantService.mine();
        return tenants;
    }
    async checkFeatures() {
        this.useFooterWithBlipStatus = await CrossAppFeatures.useFooterWithBlipStatus();
    }
}
BlipSupportController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'AuthenticationService', 'TenantService'];
